import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Card, CardHeader, CardBody, CardFooter } from 'reactstrap';
import { withFormik, Field } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';

import { renderField } from 'core/utils/formik';
import CardTitle from 'components/ui/CardTitle/CardTitle';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

const renderTitle = (initialValues) => {
  let type;
  switch (initialValues.type) {
    case 'electret':
      type = 'Electret Reader';
      break;
    default:
      type = 'CRM (Continuous Radon Monitor)';
  }
  return initialValues.id ? 'Edit Device' : `Add ${type}`;
};

const renderCalibrationDateLabel = ({ type }) => {
  return (type === 'electret' ? 'Reader\'s Next Calibration Date' : 'Next Calibration Date');
};

const DeviceForm = (props) => {
  const { handleSubmit, isSubmitting, isValid, values } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Card className="pageCard">
        <CardHeader>
          <CardTitle>{renderTitle(values)}</CardTitle>
        </CardHeader>
        <CardBody className="padded">
          <Field
            type="text"
            name="manufacturer"
            label="Lab or Manufacturer/Model"
            component={renderField}
            required
          />

          <Field
            type="text"
            name="deviceable.serial_number"
            label="Serial Number"
            component={renderField}
            required
          />

          <Field
            type="date"
            dateFormat="m/d/Y"
            name="deviceable.calibration_date"
            label={renderCalibrationDateLabel(values)}
            component={renderField}
            required
          />

          <Field
            type="text"
            name="label"
            label="Label"
            component={renderField}
            helpText="used internally to identify device"
          />
        </CardBody>
        <CardFooter>
          <Button
            type="submit"
            color="primary"
            disabled={!isValid || isSubmitting}
          >
            Save
          </Button>
        </CardFooter>
      </Card>
    </Form>
  );
};

DeviceForm.propTypes = propTypes;

const setValidationSchema = () => Yup.object().shape({
  manufacturer: Yup.string().required('Required'),
  deviceable: Yup.object().shape({
    serial_number: Yup.string().required('Required'),
    calibration_date: Yup.string().required('Required'),
  }),
});

export default withFormik({
  mapPropsToValues: ({ initialValues }) => {
    const { id, manufacturer, label, deviceable } = initialValues;
    const formValues = Object.assign(initialValues);

    if (id) {
      const { calibration_date } = deviceable;
      formValues.deviceable.calibration_date = moment(calibration_date).toISOString();
    }

    if (!manufacturer) { formValues.manufacturer = ''; }
    if (!label) { formValues.label = ''; }
    if (!deviceable) {
      formValues.deviceable = {
        serial_number: '',
        calibration_date: '',
      };
    }

    return formValues;
  },
  validationSchema: () => setValidationSchema(),
  handleSubmit: (values, formikBag) => {
    const { setSubmitting, props: { onSubmit } } = formikBag;
    onSubmit(values, setSubmitting);
  },
  isInitialValid: ({ initialValues }) => {
    const { id } = initialValues;
    const schema = setValidationSchema(id);
    const result = schema.isValidSync(initialValues);
    return result;
  },
})(DeviceForm);



// WEBPACK FOOTER //
// ./src/features/device/DeviceForm.js